import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import { isToday, searchWord } from '../../../helpers/common';
import { setSelectedLoadIds, approveLoad } from '../../../actions/load';
import { getGeoStorageLocation } from '../../../actions/geo';
import { Unit } from '../../../helpers/unit';
import LoadCardOne from './LoadCardOne';
import LoadCardTwo from './LoadCardTwo';
import { useLoadQueueContext } from './context/LoadQueueContext';
import moment from 'moment';
import { getRangeType, getTimezoneIdentifier } from '../../../helpers/session';

const LoadQueueList = props => {
	const dispatch = useDispatch();
	const farmConfig = useSelector(state => state.farm.farmSettings.farm_config);
	const isRequesting = useSelector(state => state.load.loadQueueList.isRequesting);
	const {
		loadQueueType,
		unLoadSiteList,
		selectedLoadIds,
		loadQueueInput: loadQueueInputs,
		loadQueueSortOrder,
		loadQueueFilterIds
	} = useSelector(state => state.load);
	const { rangeId } = useSelector(state => state.analyze.searchParams);
	const loadList = useSelector(state => state.load.loadQueueList.data);

	const {
		farmId,
		loadMoreCount,
		setLoadMoreCount,
		searchText,
		dropDownVisible,
		formDatas,
		isApproveDataValid
	} = props;

	const {
		approving,
		setApproving,
		setMultiApporveData,
		isEdited,
		setIsEdited,
		editedLoadsById,
		setEditedLoadsById
	} = useLoadQueueContext();
	const unit = Unit.getInstance();

	useEffect(() => {
		setEditedLoadsById({});
		setIsEdited(false);
		if (selectedLoadIds.length > 0) dispatch(setSelectedLoadIds([]));
	}, [farmId, loadQueueType, rangeId]);

	useEffect(() => {
		setLoadMoreCount(1);
		if (!isEdited) setEditedLoadsById({});
	}, [isEdited]);

	useEffect(() => {
		if (selectedLoadIds.length === 0) {
			setMultiApporveData({});
			setEditedLoadsById({});
			setIsEdited(false);
		}
	}, [selectedLoadIds]);

	const matchWord = item =>
	((item.targetEquipmentGroupName && searchWord(item.targetEquipmentGroupName, searchText)) ||
		(item.sourceEquipmentGroupName && searchWord(item.sourceEquipmentGroupName, searchText)) ||
		(item.crewName && searchWord(item.crewName, searchText)));

	const handleChange = (id, data) => {
		data = {
			...data, ...data.loadCapacity ? { loadCapacity: unit.fromWeight(data.loadCapacity) } : {},
			...data.tareWeight ? { tareWeight: unit.fromWeight(data.tareWeight) } : {},
			...data.loadGrossWeight ? { loadGrossWeight: unit.fromWeight(data.loadGrossWeight) } : {},
			...data.lightWeight ? { lightWeight: unit.fromWeight(data.lightWeight) } : {}
		};
		const newEditedLoadsById = { ...editedLoadsById };
		if (selectedLoadIds.indexOf(id) >= 0)
			selectedLoadIds.forEach(id => newEditedLoadsById[id] = { ...newEditedLoadsById[id], ...data });
		else newEditedLoadsById[id] = { ...newEditedLoadsById[id], ...data };
		setEditedLoadsById(newEditedLoadsById);
		if (!isEdited) setIsEdited(true);
	};

	const handleMultiApprove = () => {
		setApproving(true);
		const seletedLoads = loadList.filter(item => selectedLoadIds.indexOf(item.loadActivityId) >= 0);
		const approvalLoads = seletedLoads.map(item => ({ ...item, ...editedLoadsById[item.loadActivityId] }));
		const data = [];

		const { offloadGeoShapeId, offloadStorageLocationId, offloadStoragePipe } = loadQueueInputs;
		const findShape = offloadGeoShapeId ? unLoadSiteList.filter(e => e.geo_shape_uuid === offloadGeoShapeId) : [];

		approvalLoads.forEach(item => {
			const offload_geo_shape_uuid = offloadGeoShapeId ? offloadGeoShapeId : (item && item.offloadGeoShapeId) ? item.offloadGeoShapeId : null;
			const offload_geo_region_name = (findShape.length > 0) ? findShape[0].geo_region_name : (item && item.offloadGeoRegionName) ? item.offloadGeoRegionName : null;
			const offload_geo_region_uuid = (findShape.length > 0) ? findShape[0].geo_region_uuid : (item && item.offloadGeoRegionId) ? item.offloadGeoRegionId : null;
			const offload_geo_shape_name = (findShape.length > 0) ? findShape[0].geo_shape_name : (item && item.offloadGeoShapeName) ? item.offloadGeoShapeName : null;
			const offload_geo_storage_location_uuid = offloadStorageLocationId ? offloadStorageLocationId : (item && item.offloadStorageLocationId) ? item.offloadStorageLocationId : null;

			const params = {
				farm_uuid: farmId,
				source_equipment_group_uuid: item.sourceEquipmentGroupId,
				target_equipment_group_uuid: item.targetEquipmentGroupId,
				load_activity_uuid: item.loadActivityId,
				load_capacity: item.loadCapacity,
				light_weight: item.lightWeight ? item.lightWeight : null,
				offload_geo_shape_uuid,
				offload_geo_region_name,
				offload_geo_region_uuid,
				offload_geo_shape_name,
				offload_geo_storage_location_uuid,
				tare_weight: item.tareWeight ? Number(item.tareWeight) : null,
				load_gross_weight: item.loadGrossWeight ? Number(item.loadGrossWeight) : null,
				pipe: offloadStoragePipe ? offloadStoragePipe : item.pipe ? item.pipe : null,
				pipeId: offloadStoragePipe ? offloadStoragePipe : item.pipeId ? item.pipeId : null,
				load_params: item.load_params ? item.load_params : null
			};
			data.push(params);
		});
		dispatch(approveLoad({ farm_uuid: farmId, loads: data }, (isApproved) => {
			if (isApproved) {
				// update offload default storage location
				const defaultStorageLocations = data.filter(e => e.offload_geo_storage_location_uuid === 'default');
				let geo_region_shape_uuid = defaultStorageLocations.map((item) => {
					const findShape = unLoadSiteList.find(e => e.geo_shape_uuid === item.offload_geo_shape_uuid) || {};
					return findShape.geo_shape_object_uuid;
				}).filter(geoShapeObjectId => Boolean(geoShapeObjectId));
				geo_region_shape_uuid = [...new Set(geo_region_shape_uuid)].join(',');

				geo_region_shape_uuid && dispatch(getGeoStorageLocation({ geo_region_shape_uuid }));

				dispatch(setSelectedLoadIds([]));
				setIsEdited(false);
			}
			setApproving(false);
		}));
	};

	const getFilteredList = (loadList) => {
		let filterList = loadList;
		if (loadQueueFilterIds != null) filterList = filterList.filter(e => loadQueueFilterIds.indexOf(e.loadActivityId) >= 0);
		if (searchText) filterList = filterList.filter(matchWord);
		filterList = loadQueueSortOrder === 1
			? filterList.sort((a, b) => new Date(a.loadDate).getTime() - new Date(b.loadDate).getTime())
			: filterList.sort((a, b) => new Date(b.loadDate).getTime() - new Date(a.loadDate).getTime());
		return ({ filteredList: filterList });
	};

	const { filteredList } = getFilteredList(loadList);
	const list = filteredList.slice(0, loadMoreCount * 10);
	const timezone = getTimezoneIdentifier();
	const range = getRangeType(timezone);
	const now = moment().tz(timezone);
	const startDay = moment(now).startOf("days");
	let firstRecentLoadActivityId = list.filter(it => moment(it.loadDate).isBefore(startDay));
	firstRecentLoadActivityId = firstRecentLoadActivityId && firstRecentLoadActivityId.length > 0 ?
		firstRecentLoadActivityId[0].loadActivityId : null;
	const isRecentVisible = farmConfig && farmConfig.load_queue_recent_hours && farmConfig.load_queue_recent_hours.recent_hours ? farmConfig.load_queue_recent_hours.recent_hours : 0;

	return <div className={`load-queue-list ${loadQueueType === 2 ? "history-view" : ""}`}>
		{isRequesting &&
			<span className="loading">Loading...</span>}
		{!isRequesting && filteredList.length === 0 &&
			<span className="no-records-found">No Loads in Queue</span>}
		{!isRequesting && list.length > 0 &&
			list.map(e =>
				<div key={`loadQueue_${e.loadActivityId}`}>
					{e.approved ?
						<LoadCardTwo load={{ ...e, farmId }} /> :
						<>
							{isRecentVisible && isToday(range) && (firstRecentLoadActivityId && e.loadActivityId === firstRecentLoadActivityId) ?
								<div className='recent-splitter'>Recent</div>
								: null}
							<LoadCardOne
								load={{ ...e, farmId }}
								multipleApproving={approving && selectedLoadIds.indexOf(e.loadActivityId) >= 0}
								onChange={handleChange}
								onMultiApprove={handleMultiApprove}
								setIsEdited={setIsEdited}
								formDatas={(dropDownVisible && formDatas && formDatas.length > 0) ? formDatas : []}
								isApproveDataValid={isApproveDataValid}
							/>
						</>}
				</div>)}
		{filteredList.length !== 0 && loadMoreCount * 10 < filteredList.length && <div className="load-more mt-2 pb-2">
			<Button variant="outline-primary" size="sm" onClick={() => setLoadMoreCount(loadMoreCount + 1)}>Load more...</Button>
		</div>}
	</div>;
};


export default LoadQueueList;